<template><markdown-wrapper><h1 id="collapse">Collapse <a class="header-anchor" href="#collapse">&#128279;</a></h1>
<blockquote>
<p>Flexible plugin for easy toggle behavior.</p>
</blockquote>
<p><ins class="adsbygoogle"
     style="display:block; text-align:center;"
     data-ad-layout="in-article"
     data-ad-format="fluid"
     data-ad-client="ca-pub-4714899946256166"
     data-ad-slot="4603582855"></ins></p>
<h2 id="example">Example <a class="header-anchor" href="#example">&#128279;</a></h2>
<p>Click the button below to show and hide another element.</p>
<collapse-example ref="collapse-example"/>
<pre v-pre><code v-pre class="language-html"><span class="hljs-tag">&lt;<span class="hljs-name">template</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">section</span>&gt;</span>
    <span class="hljs-tag">&lt;<span class="hljs-name">div</span>&gt;</span>
      <span class="hljs-tag">&lt;<span class="hljs-name">btn</span> <span class="hljs-attr">type</span>=<span class="hljs-string">&quot;primary&quot;</span> @<span class="hljs-attr">click</span>=<span class="hljs-string">&quot;show=!show&quot;</span>&gt;</span>Click me!<span class="hljs-tag">&lt;/<span class="hljs-name">btn</span>&gt;</span>
    <span class="hljs-tag">&lt;/<span class="hljs-name">div</span>&gt;</span>
    <span class="hljs-tag">&lt;<span class="hljs-name">br</span>/&gt;</span>
    <span class="hljs-tag">&lt;<span class="hljs-name">collapse</span> <span class="hljs-attr">v-model</span>=<span class="hljs-string">&quot;show&quot;</span>&gt;</span>
      <span class="hljs-tag">&lt;<span class="hljs-name">div</span> <span class="hljs-attr">class</span>=<span class="hljs-string">&quot;well&quot;</span> <span class="hljs-attr">style</span>=<span class="hljs-string">&quot;margin-bottom: 0&quot;</span>&gt;</span>Hi there.<span class="hljs-tag">&lt;/<span class="hljs-name">div</span>&gt;</span>
    <span class="hljs-tag">&lt;/<span class="hljs-name">collapse</span>&gt;</span>
  <span class="hljs-tag">&lt;/<span class="hljs-name">section</span>&gt;</span>
<span class="hljs-tag">&lt;/<span class="hljs-name">template</span>&gt;</span>
<span class="hljs-tag">&lt;<span class="hljs-name">script</span>&gt;</span><span class="language-javascript">
  <span class="hljs-keyword">export</span> <span class="hljs-keyword">default</span> {
    <span class="hljs-title function_">data</span> () {
      <span class="hljs-keyword">return</span> {
        <span class="hljs-attr">show</span>: <span class="hljs-literal">false</span>
      }
    }
  }
</span><span class="hljs-tag">&lt;/<span class="hljs-name">script</span>&gt;</span>
<span class="hljs-comment">&lt;!-- collapse-example.vue --&gt;</span>
</code></pre>
<h2 id="accordion">Accordion <a class="header-anchor" href="#accordion">&#128279;</a></h2>
<p>Extend the default collapse behavior to create an accordion with the panel component.</p>
<collapse-accordion ref="collapse-accordion"/>
<pre v-pre><code v-pre class="language-html"><span class="hljs-tag">&lt;<span class="hljs-name">template</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">div</span> <span class="hljs-attr">class</span>=<span class="hljs-string">&quot;panel-group&quot;</span>&gt;</span>
    <span class="hljs-tag">&lt;<span class="hljs-name">div</span> <span class="hljs-attr">class</span>=<span class="hljs-string">&quot;panel panel-default&quot;</span>&gt;</span>
      <span class="hljs-tag">&lt;<span class="hljs-name">div</span> <span class="hljs-attr">class</span>=<span class="hljs-string">&quot;panel-heading&quot;</span> <span class="hljs-attr">role</span>=<span class="hljs-string">&quot;button&quot;</span> @<span class="hljs-attr">click</span>=<span class="hljs-string">&quot;toggleAccordion(0)&quot;</span>&gt;</span>
        <span class="hljs-tag">&lt;<span class="hljs-name">h4</span> <span class="hljs-attr">class</span>=<span class="hljs-string">&quot;panel-title&quot;</span>&gt;</span>Collapsible Group Item #1<span class="hljs-tag">&lt;/<span class="hljs-name">h4</span>&gt;</span>
      <span class="hljs-tag">&lt;/<span class="hljs-name">div</span>&gt;</span>
      <span class="hljs-tag">&lt;<span class="hljs-name">collapse</span> <span class="hljs-attr">v-model</span>=<span class="hljs-string">&quot;showAccordion[0]&quot;</span>&gt;</span>
        <span class="hljs-tag">&lt;<span class="hljs-name">div</span> <span class="hljs-attr">class</span>=<span class="hljs-string">&quot;panel-body&quot;</span>&gt;</span>
          Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. 3 wolf
          moon officia aute, non cupidatat skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod.
        <span class="hljs-tag">&lt;/<span class="hljs-name">div</span>&gt;</span>
      <span class="hljs-tag">&lt;/<span class="hljs-name">collapse</span>&gt;</span>
    <span class="hljs-tag">&lt;/<span class="hljs-name">div</span>&gt;</span>
    <span class="hljs-tag">&lt;<span class="hljs-name">div</span> <span class="hljs-attr">class</span>=<span class="hljs-string">&quot;panel panel-default&quot;</span>&gt;</span>
      <span class="hljs-tag">&lt;<span class="hljs-name">div</span> <span class="hljs-attr">class</span>=<span class="hljs-string">&quot;panel-heading&quot;</span> <span class="hljs-attr">role</span>=<span class="hljs-string">&quot;button&quot;</span> @<span class="hljs-attr">click</span>=<span class="hljs-string">&quot;toggleAccordion(1)&quot;</span>&gt;</span>
        <span class="hljs-tag">&lt;<span class="hljs-name">h4</span> <span class="hljs-attr">class</span>=<span class="hljs-string">&quot;panel-title&quot;</span>&gt;</span>Collapsible Group Item #2<span class="hljs-tag">&lt;/<span class="hljs-name">h4</span>&gt;</span>
      <span class="hljs-tag">&lt;/<span class="hljs-name">div</span>&gt;</span>
      <span class="hljs-tag">&lt;<span class="hljs-name">collapse</span> <span class="hljs-attr">v-model</span>=<span class="hljs-string">&quot;showAccordion[1]&quot;</span>&gt;</span>
        <span class="hljs-tag">&lt;<span class="hljs-name">div</span> <span class="hljs-attr">class</span>=<span class="hljs-string">&quot;panel-body&quot;</span>&gt;</span>
          Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. 3 wolf
          moon officia aute, non cupidatat skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod.
        <span class="hljs-tag">&lt;/<span class="hljs-name">div</span>&gt;</span>
      <span class="hljs-tag">&lt;/<span class="hljs-name">collapse</span>&gt;</span>
    <span class="hljs-tag">&lt;/<span class="hljs-name">div</span>&gt;</span>
    <span class="hljs-tag">&lt;<span class="hljs-name">div</span> <span class="hljs-attr">class</span>=<span class="hljs-string">&quot;panel panel-info&quot;</span>&gt;</span>
      <span class="hljs-tag">&lt;<span class="hljs-name">div</span> <span class="hljs-attr">class</span>=<span class="hljs-string">&quot;panel-heading&quot;</span> <span class="hljs-attr">role</span>=<span class="hljs-string">&quot;button&quot;</span> @<span class="hljs-attr">click</span>=<span class="hljs-string">&quot;toggleAccordion(2)&quot;</span>&gt;</span>
        <span class="hljs-tag">&lt;<span class="hljs-name">h4</span> <span class="hljs-attr">class</span>=<span class="hljs-string">&quot;panel-title&quot;</span>&gt;</span>Collapsible Group Item #3<span class="hljs-tag">&lt;/<span class="hljs-name">h4</span>&gt;</span>
      <span class="hljs-tag">&lt;/<span class="hljs-name">div</span>&gt;</span>
      <span class="hljs-tag">&lt;<span class="hljs-name">collapse</span> <span class="hljs-attr">v-model</span>=<span class="hljs-string">&quot;showAccordion[2]&quot;</span>&gt;</span>
        <span class="hljs-tag">&lt;<span class="hljs-name">div</span> <span class="hljs-attr">class</span>=<span class="hljs-string">&quot;panel-body&quot;</span>&gt;</span>
          Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. 3 wolf
          moon officia aute, non cupidatat skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod.
        <span class="hljs-tag">&lt;/<span class="hljs-name">div</span>&gt;</span>
      <span class="hljs-tag">&lt;/<span class="hljs-name">collapse</span>&gt;</span>
    <span class="hljs-tag">&lt;/<span class="hljs-name">div</span>&gt;</span>
  <span class="hljs-tag">&lt;/<span class="hljs-name">div</span>&gt;</span>
<span class="hljs-tag">&lt;/<span class="hljs-name">template</span>&gt;</span>
<span class="hljs-tag">&lt;<span class="hljs-name">script</span>&gt;</span><span class="language-javascript">
  <span class="hljs-keyword">export</span> <span class="hljs-keyword">default</span> {
    <span class="hljs-title function_">data</span> () {
      <span class="hljs-keyword">return</span> {
        <span class="hljs-attr">showAccordion</span>: [<span class="hljs-literal">true</span>, <span class="hljs-literal">false</span>, <span class="hljs-literal">false</span>]
      }
    },
    <span class="hljs-attr">methods</span>: {
      <span class="hljs-title function_">toggleAccordion</span> (index) {
        <span class="hljs-keyword">if</span> (<span class="hljs-variable language_">this</span>.<span class="hljs-property">showAccordion</span>[index]) {
          <span class="hljs-variable language_">this</span>.$set(<span class="hljs-variable language_">this</span>.<span class="hljs-property">showAccordion</span>, index, <span class="hljs-literal">false</span>)
        } <span class="hljs-keyword">else</span> {
          <span class="hljs-variable language_">this</span>.<span class="hljs-property">showAccordion</span> = <span class="hljs-variable language_">this</span>.<span class="hljs-property">showAccordion</span>.<span class="hljs-title function_">map</span>(<span class="hljs-function">(<span class="hljs-params">v, i</span>) =&gt;</span> i === index)
        }
      }
    }
  }
</span><span class="hljs-tag">&lt;/<span class="hljs-name">script</span>&gt;</span>
<span class="hljs-comment">&lt;!-- collapse-accordion.vue --&gt;</span>
</code></pre>
<h1 id="api-reference">API Reference <a class="header-anchor" href="#api-reference">&#128279;</a></h1>
<h2 id="collapse-1"><a href="https://github.com/wxsms/uiv/blob/0.x/src/components/collapse/Collapse.vue">Collapse</a> <a class="header-anchor" href="#collapse-1">&#128279;</a></h2>
<h3 id="props">Props <a class="header-anchor" href="#props">&#128279;</a></h3>
<div class="table-responsive"><table class="table table-bordered table-hover"><thead>
<tr>
<th>Name</th>
<th>Type</th>
<th>Default</th>
<th>Required</th>
<th>Description</th>
</tr>
</thead>
<tbody>
<tr>
<td><code v-pre>v-model</code></td>
<td>Boolean</td>
<td>false</td>
<td>✔</td>
<td>Show / hide the component.</td>
</tr>
<tr>
<td><code v-pre>tag</code></td>
<td>String</td>
<td>div</td>
<td></td>
<td>The HTML tag that render the collapse component.</td>
</tr>
<tr>
<td><code v-pre>transition-duration</code></td>
<td>Number</td>
<td>350</td>
<td></td>
<td>Collapse transition speed. Use 0 to disable transition.</td>
</tr>
</tbody>
</table></div><h3 id="slots">Slots <a class="header-anchor" href="#slots">&#128279;</a></h3>
<div class="table-responsive"><table class="table table-bordered table-hover"><thead>
<tr>
<th>Name</th>
<th>Description</th>
</tr>
</thead>
<tbody>
<tr>
<td><code v-pre>default</code></td>
<td>Replace as the collapse body.</td>
</tr>
</tbody>
</table></div><h3 id="events">Events <a class="header-anchor" href="#events">&#128279;</a></h3>
<div class="table-responsive"><table class="table table-bordered table-hover"><thead>
<tr>
<th>Name</th>
<th>Params</th>
<th>Description</th>
</tr>
</thead>
<tbody>
<tr>
<td><code v-pre>show</code></td>
<td></td>
<td>This event fires immediately when the v-model prop is set to true.</td>
</tr>
<tr>
<td><code v-pre>shown</code></td>
<td></td>
<td>This event is fired when a collapse element has been made visible to the user (will wait for CSS transitions to complete).</td>
</tr>
<tr>
<td><code v-pre>hide</code></td>
<td></td>
<td>This event is fired immediately when the v-model prop is set to false.</td>
</tr>
<tr>
<td><code v-pre>hidden</code></td>
<td></td>
<td>This event is fired when a collapse element has been hidden from the user (will wait for CSS transitions to complete).</td>
</tr>
</tbody>
</table></div></markdown-wrapper></template><script>
  

  
export default {components:{'collapse-example':{"template":"<div class=\"markdown-live-example\">\n  <section>\n    <div>\n      <btn type=\"primary\" @click=\"show=!show\">Click me!</btn>\n    </div>\n    <br/>\n    <collapse v-model=\"show\">\n      <div class=\"well\" style=\"margin-bottom: 0\">Hi there.</div>\n    </collapse>\n  </section>\n</div>",
    data () {
      return {
        show: false
      }
    }
  },'collapse-accordion':{"template":"<div class=\"markdown-live-example\">\n  <div class=\"panel-group\">\n    <div class=\"panel panel-default\">\n      <div class=\"panel-heading\" role=\"button\" @click=\"toggleAccordion(0)\">\n        <h4 class=\"panel-title\">Collapsible Group Item #1</h4>\n      </div>\n      <collapse v-model=\"showAccordion[0]\">\n        <div class=\"panel-body\">\n          Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. 3 wolf\n          moon officia aute, non cupidatat skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod.\n        </div>\n      </collapse>\n    </div>\n    <div class=\"panel panel-default\">\n      <div class=\"panel-heading\" role=\"button\" @click=\"toggleAccordion(1)\">\n        <h4 class=\"panel-title\">Collapsible Group Item #2</h4>\n      </div>\n      <collapse v-model=\"showAccordion[1]\">\n        <div class=\"panel-body\">\n          Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. 3 wolf\n          moon officia aute, non cupidatat skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod.\n        </div>\n      </collapse>\n    </div>\n    <div class=\"panel panel-info\">\n      <div class=\"panel-heading\" role=\"button\" @click=\"toggleAccordion(2)\">\n        <h4 class=\"panel-title\">Collapsible Group Item #3</h4>\n      </div>\n      <collapse v-model=\"showAccordion[2]\">\n        <div class=\"panel-body\">\n          Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. 3 wolf\n          moon officia aute, non cupidatat skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod.\n        </div>\n      </collapse>\n    </div>\n  </div>\n</div>",
    data () {
      return {
        showAccordion: [true, false, false]
      }
    },
    methods: {
      toggleAccordion (index) {
        if (this.showAccordion[index]) {
          this.$set(this.showAccordion, index, false)
        } else {
          this.showAccordion = this.showAccordion.map((v, i) => i === index)
        }
      }
    }
  }}}</script>